const actionTypes = require('constants/actionTypes');
const signaturePatternActions = require('actions/signaturePattern');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIPost } = require('utilities/APIRequestHelper');
const { requestCards } = require('actions/getMyCards');
const { FIRST_STEP } = require('constants/index');

function setVisibleStep(step) {
    return {
        type: actionTypes.CARD_SECURE_PAYMENT_SET_VISIBLE_STEP,
        payload: {
            step
        }
    };
}

function validateStep(step) {
    return {
        type: actionTypes.CARD_SECURE_PAYMENT_VALIDATE_STEP,
        payload: {
            step
        }
    }
}

function setWillCancel(willCancel) {
    return {
        type: actionTypes.CARD_SECURE_PAYMENT_WILL_CANCEL,
        payload: {
            willCancel
        }
    };
}

function resetView() {
    return {
        type: actionTypes.CARD_SECURE_PAYMENT_RESET_VIEW
    };
}

function requestConfigurationSuccess(response) {
    return {
        type: actionTypes.CARD_SECURE_PAYMENT_SETUP_SUCCESS,
        payload: response
    }
}

function requestConfigurationFailure(response) {
    return {
        type: actionTypes.CARD_SECURE_PAYMENT_SETUP_FAILURE,
        payload: response
    }
}


function fetchCardSecurePaymentConfiguration() {
    return {
        type: actionTypes.FETCH_CARD_SECURE_PAYMENT_CONFIGURATION
    }
}

function saveConfigurationRequest() {
    return {
        type: actionTypes.CARD_SECURE_PAYMENT_SAVE_SETUP_REQUEST
    }
}

function saveConfigurationSuccess(response) {
    return {
        type: actionTypes.CARD_SECURE_PAYMENT_SAVE_SETUP_SUCCESS,
        payload: response
    }
}

function saveConfigurationFailure(response) {
    return {
        type: actionTypes.CARD_SECURE_PAYMENT_SAVE_SETUP_FAILURE,
        payload: response
    }
}

const postChange = (cardId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCard = getState().cards.getIn(['byId', cardId]);
        const immCardSecurePaymentData = getState().cardSecurePayment.getIn(['steps',FIRST_STEP]);

        const requestData = {
            query: {
                dataToken,
                contrato: {
                    numerodecontrato: immCard.getIn(['contract', 'number']),
                    producto:  immCard.getIn(['contract', 'product'])
                },
                indCESactual: immCardSecurePaymentData.get('isSecureCommerceCheckedLast') ? 1 : 0,
                indCESnuevo: immCardSecurePaymentData.get('isSecureCommerceChecked') ? 1 : 0,
                indPNSactual: immCardSecurePaymentData.get('isNoSecureCommerceCheckedLast') ? 0 : 1,  // It's opposite to CES
                indPNSnuevo: immCardSecurePaymentData.get('isNoSecureCommerceChecked') ? 0 : 1, // It's opposite to CES
                pan: immCard.get('number')
            }
        }

        dispatch(saveConfigurationRequest());
        return APIPost(
            dispatch,
            apiURLBuilder.getURL('setCardSecurePayment'),
            requestData)
            .then(responseSuccess => dispatch(saveConfigurationSuccess(responseSuccess)))
            .catch(responseFailure => dispatch(saveConfigurationFailure(responseFailure)))
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
}

const getCardSecurePaymentConfiguration = (immCard) => (dispatch) => {
    return dispatch(requestCards())
        .then(() => {
            const requestData = {
                query: {
                    producto: immCard.getIn(['contract', 'product']),
                    numeroContrato: immCard.getIn(['contract', 'number']),
                    pan: immCard.get('number')
                }
            };
            dispatch(fetchCardSecurePaymentConfiguration());
                return APIPost({
                    dispatch,
                    endpoint: 'cardSecurePayment',
                    params: requestData
                })
                .then(responseSuccess => dispatch(requestConfigurationSuccess(responseSuccess)))
                .catch(responseFailure => dispatch(requestConfigurationFailure(responseFailure)));
        })
}

function secureCommerceChanged(checked) {
    return {
        type: actionTypes.CARD_SECURE_PAYMENT_SECURE_COMMERCE_CHANGES,
        payload: {
            allowSecureCommerce: checked
        }
    };
}

function noSecureCommerceChanged(checked) {
    return {
        type: actionTypes.CARD_SECURE_PAYMENT_NO_SECURE_COMMERCE_CHANGES,
        payload: {
            allowNoSecureCommerce: checked
        }
    };
}

module.exports = {
    setVisibleStep,
    validateStep,
    setWillCancel,
    postChange,
    resetView,
    secureCommerceChanged,
    noSecureCommerceChanged,
    getCardSecurePaymentConfiguration
}
